import styles from './styles.module.css';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

function CTA(){
    return(
        <section className={styles.ctaSection}>
            <div className={styles.ctaBox}>
                <h2 className={styles.ctaTitle}>Pronto para simplificar sua gestão?</h2>
                <p className={styles.ctaDesc}>Junte-se a centenas de freelancers que já usam o Orçamento Digital.</p>
                <Link to="/register" className={styles.btnPrimary}>
                    Criar conta grátis <ArrowRight size={18} />
                </Link>
            </div>
        </section>
    );
}

export default CTA;